import { isEmpty } from 'lodash';
import { IContentPackItem, ITEM_TYPE } from '@sitegen/common/types';
import { IUplayClientProduct } from './pyc-redeem.types';
import { IUPCProductOwnership, MAX_GAMES_AMOUNT } from './pyc-redeem.constants';

export const matchGamesByStatus = (
    contentPackItems: IContentPackItem[],
    redeemProducts: IUplayClientProduct[]
) => {
    const redeemOwnedGameIds: number[] = redeemProducts
        .filter(item => item.ownership === IUPCProductOwnership.OWNED)
        .map(item => item.id);

    const matchedGameItems = contentPackItems
        .filter(item => item.type === ITEM_TYPE.KEY_DELIVERY)
        .filter((_item, index) => index < MAX_GAMES_AMOUNT)
        .map(game => {
            const hasOwnedGame = game.ownershipGroups?.some(group =>
                group.every(id => redeemOwnedGameIds.includes(parseInt(id, 10)))) ?? false;
            return ({
                ...game,
                alreadyOwned: hasOwnedGame
            });
        });

    return matchedGameItems;
};

export const getAvailableContentPackItems = (
    contentPackItems: IContentPackItem[],
    availableItems: string[]
) => {
    return contentPackItems.reduce((acc, item) => {
        if (item.hidden || isEmpty(item.actionIds)) {
            return acc;
        }
    
        const preparedItem = {
            ...item,
            actionIds: item.actionIds!.filter(id => availableItems.includes(id))
        };
    
        return preparedItem.actionIds.length ? [...acc, preparedItem] : acc;
    }, []) as IContentPackItem[];
};
